<main itemscope itemtype="https://schema.org/CollectionPage">
  <!-- METADATOS INVISIBLES AEO PARA BÚSQUEDA Y MOTOR DE RESPUESTAS IA -->
  <meta itemprop="name" content="Universo Estancos — Coctelería de Autor, Maridaje y Galería de Patrimonio" />
  <meta itemprop="description" content="Explora el universo gastronómico de Estancos Distilling Co. Recetas de coctelería artesanal, maridajes perfectos con Ron Legarda y Whisky Real Audiencia, y galería fotográfica a 2500 msnm." />

  <!-- BREADCRUMBS SCHEMA.ORG PARA AEO Y SEO -->
  <nav class="breadcrumb-container container" aria-label="Navegación secundaria">
    <ol class="breadcrumb-list" itemscope itemtype="https://schema.org/BreadcrumbList">
      <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem">
        <a itemprop="item" href="/">
          <span itemprop="name">Inicio</span>
        </a>
        <meta itemprop="position" content="1" />
      </li>
      <li itemprop="itemListElement" itemscope itemtype="https://schema.org/ListItem" aria-current="page">
        <span itemprop="name">Universo Estancos</span>
        <meta itemprop="position" content="2" />
      </li>
    </ol>
  </nav>

  <!-- HERO NEOCLÁSICO DE ALTA ACCESIBILIDAD -->
  <header class="content-hero">
    <div class="container">
      <div class="hero-crest" aria-hidden="true">
        <span class="crest-symbol">⚜</span>
      </div>
      <span class="hero-subtitle">Cultura, Alquimia & Experiencia</span>
      <h1 itemprop="headline">Universo Estancos</h1>
      
      <div class="classic-divider" aria-hidden="true">
        <span class="divider-line"></span>
        <span class="divider-diamond">◆</span>
        <span class="divider-line"></span>
      </div>

      <p itemprop="abstract">
        Adéntrate en nuestra cultura andina. Aprende a mezclar con la coctelería de autor, descubre la armonía del maridaje gastronómico y contempla los momentos inmortales de nuestra destilería a 2500 msnm.
      </p>
    </div>
  </header>

  <!-- PESTAÑAS NEOCLÁSICAS Y ACCESIBLES (TABLIST) -->
  <div class="container">
    <nav class="tabs-container" role="tablist" aria-label="Secciones del Universo Estancos">
      
      <!-- PESTAÑA 1: COCTELERÍA -->
      <button 
        type="button"
        class="tab-btn" 
        [class.active]="activeTab() === 'mixologia'" 
        (click)="setTab('mixologia')"
        role="tab"
        [attr.aria-selected]="activeTab() === 'mixologia'"
        aria-controls="panel-mixologia"
        id="tab-mixologia"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true" class="tab-icon">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 4.5l-15 0m15 0l-7.5 9m7.5-9v2.25m-15-2.25l7.5 9m-7.5-9v2.25m7.5 6.75v5.25m-3.75 0h7.5" />
        </svg>
        <span>Carta de Cócteles</span>
      </button>

      <!-- PESTAÑA 2: MARIDAJE -->
      <button 
        type="button"
        class="tab-btn" 
        [class.active]="activeTab() === 'maridaje'" 
        (click)="setTab('maridaje')"
        role="tab"
        [attr.aria-selected]="activeTab() === 'maridaje'"
        aria-controls="panel-maridaje"
        id="tab-maridaje"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true" class="tab-icon">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 21a9 9 0 009-9H3a9 9 0 009 9zM12 3v9" />
        </svg>
        <span>Arte del Maridaje</span>
      </button>

      <!-- PESTAÑA 3: GALERÍA -->
      <button 
        type="button"
        class="tab-btn" 
        [class.active]="activeTab() === 'galeria'" 
        (click)="setTab('galeria')"
        role="tab"
        [attr.aria-selected]="activeTab() === 'galeria'"
        aria-controls="panel-galeria"
        id="tab-galeria"
      >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" aria-hidden="true" class="tab-icon">
          <path stroke-linecap="round" stroke-linejoin="round" d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0c-.698.04-1.353.43-1.736 1.038l-.823 1.316z" />
          <path stroke-linecap="round" stroke-linejoin="round" d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0z" />
        </svg>
        <span>Nuestra Experiencia</span>
      </button>

    </nav>
  </div>

  <!-- ÁREA DE CONTENIDO DINÁMICO (RENDERIZACIÓN DE COMPONENTES) -->
  <section class="dynamic-tab-section">

    <!-- COMPONENTE: COCTELERÍA -->
    @if (activeTab() === 'mixologia') {
      <div 
        id="panel-mixologia" 
        class="tab-wrapper" 
        role="tabpanel" 
        aria-labelledby="tab-mixologia"
      >
        <app-cocteleria></app-cocteleria>
      </div>
    }

    <!-- COMPONENTE: MARIDAJE -->
    @if (activeTab() === 'maridaje') {
      <div 
        id="panel-maridaje" 
        class="tab-wrapper" 
        role="tabpanel" 
        aria-labelledby="tab-maridaje"
      >
        <app-maridaje></app-maridaje>
      </div>
    }

    <!-- COMPONENTE: GALERÍA -->
    @if (activeTab() === 'galeria') {
      <div 
        id="panel-galeria" 
        class="tab-wrapper" 
        role="tabpanel" 
        aria-labelledby="tab-galeria"
      >
        <app-galeria></app-galeria>
      </div>
    }

  </section>
</main>
